var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgConnectIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 34 34"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#connect-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m13.406 18.825.098-1.998a7 7 0 0 1 7.337-6.646l.5.024a7 7 0 1 1-.691 13.983l.099-1.997a5 5 0 1 0 .493-9.988l-.5-.025a5 5 0 0 0-5.24 4.748l-.099 1.997zM13.35 9.81l-.099 1.998a5 5 0 0 0-.493 9.987l.5.025a5 5 0 0 0 5.24-4.747l.099-1.998 1.997.099-.098 1.997a7 7 0 0 1-7.337 6.647l-.5-.025a7 7 0 1 1 .691-13.983"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "connect-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.163 33.95.05 16.163 17.837.05 33.95 17.836z"
})))));
export { SvgConnectIcon as ReactComponent };
export default __webpack_public_path__ + "28ba9d0df35a0fc1a1ad4a17d73e712b.svg";